import { Component } from '@angular/core';
import { LoaderService } from '../../shared/services/loader.service';
import { PowerBiReportService } from '../../shared/services/power-bi-report.service';
import { UserService } from '../../user-dashboard/shared/user.service';
import { finalize } from 'rxjs/operators';
import { Report } from '../shared/report.model';

@Component({
  selector: 'app-report-overview',
  templateUrl: './report-overview.component.html',
  styleUrls: ['./report-overview.component.scss']
})
export class ReportOverviewComponent {

  reports: Report[] = [];
  reportIdSelected: string;

  constructor(private readonly powerBiReportService: PowerBiReportService,
              private readonly loaderService: LoaderService,
              private userService: UserService) {
    this.loaderService.startLoad(false);

    this.userService.getSelfReports()
      .pipe(finalize(() => this.loaderService.stopLoad()))
      .subscribe((reports: Report[]) => {
        this.reports = reports;
      });
  }

}
